// This code copied from stackoverflow
// don't trust this code
function base64(uriComponent) {
  return window.btoa(unescape(encodeURIComponent(uriComponent)));
}

function format(string, context) {
  return string.replace(/{(\w+)}/g, (_, p) => context[p]);
}

const uri = 'data:application/vnd.ms-excel;base64,';
const template =
  '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-mic' +
  'rosoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta cha' +
  'rset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:Exce' +
  'lWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/>' +
  '</x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></' +
  'xml><![endif]--></head><body>{table}</body></html>';

function createTable(tablePayload) {
  if (!tablePayload || !Array.isArray(tablePayload)) {
    return '<table><tr><td>No data available</td></tr></table>';
  }
  
  let table = '<table>';
  
  // Add header row if first row contains headers
  if (tablePayload.length > 0) {
    table += '<tr>';
    const firstRow = tablePayload[0];
    if (typeof firstRow === 'object' && firstRow !== null) {
      Object.keys(firstRow).forEach(key => {
        table += `<th>${key}</th>`;
      });
    } else {
      table += '<th>Data</th>';
    }
    table += '</tr>';
  }
  
  // Add data rows
  tablePayload.forEach(row => {
    table += '<tr>';
    if (typeof row === 'object' && row !== null) {
      Object.values(row).forEach(value => {
        table += `<td>${value || ''}</td>`;
      });
    } else {
      table += `<td>${row || ''}</td>`;
    }
    table += '</tr>';
  });
  
  table += '</table>';
  return table;
}

export { uri, template, format, base64, createTable };
